import { useRef } from 'react';
import PropTypes from 'prop-types';
import { Pie } from 'react-chartjs-2';
import { colors as themeColors } from 'Shared/util/theme';
import { formatLabelsWithPercentage } from 'Shared/components/charts/chart-utils';
import styles from './chart.css';
import stylesPie from './pie-chart.css';


const defaultColors = [themeColors.main, themeColors.alt1, themeColors.alt2, themeColors.alt3, themeColors.alt4];

const getBackgroundColor = (index, colors) => ((index < 0 || index >= colors.length) ? 'rgb(225,225,225)' : colors[index]);

const generateChartData = (labels, values, colors) => ({
  labels,
  datasets: [{
    data: values,
    backgroundColor: colors,
    borderWidth: 0,
  }],
});


const renderLegendItem = (
  index,
  label,
  onClick,
  selectedIndex,
  colors,
) => {
  const handleClick = () => (onClick ? onClick(label.name, index) : {});
  return (
    <div
      className={`${stylesPie.item} ${onClick ? stylesPie.item_clickable : ''}`}
      onClick={handleClick}
    >
      <div className={stylesPie.point} style={{ backgroundColor: getBackgroundColor(index, colors) }} />
      <div className={`${stylesPie.label} ${(onClick && selectedIndex === index) ? stylesPie.label_selected : ''}`}>
        {label.label}
      </div>
    </div>
  );
};


const PieChart = ({
  labels,
  values,
  colors,
  options,
  onClick,
  legend,
  labelTexts,
}) => {
  const chartRef = useRef();

  if (labels.length === 0) return (<div />);

  const handleElementAtEvent = (element) => (element[0] && onClick(element[0], chartRef.current));

  const chartData = generateChartData(labels.map(x => labelTexts ? labelTexts[x] || x : x), values, colors);
  const formattedLabels = formatLabelsWithPercentage(labels, values, labelTexts);

  return (
    <div className={styles.container}>
      <Pie
        data={chartData}
        options={options}
        getElementAtEvent={onClick && handleElementAtEvent}
        ref={chartRef}
      />

      <div className={stylesPie.container}>
        {formattedLabels.map((label, index) => (
          <div key={`${index};${label.name}`}>
            {renderLegendItem(
              index,
              label,
              (legend && legend.onClick),
              (legend && legend.selectedIndex),
              colors,
            )}
          </div>
        ))}
      </div>
    </div>
  );
};


PieChart.defaultProps = {
  colors: defaultColors,
};

PieChart.propTypes = {
  labels: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  colors: PropTypes.array,
  options: PropTypes.object,
  onClick: PropTypes.func,
  legend: PropTypes.shape({
    onClick: PropTypes.func,
    selectedIndex: PropTypes.number,
  }),
  labelTexts: PropTypes.object,
};

export default PieChart;
